/**
 * Blog Table of Contents
 * Scans article body for h2/h3, builds nav, tracks scroll position
 */
(function () {
  const body = document.querySelector('.blog-article__body');
  const tocDesktop = document.querySelector('.blog-article__toc-list:not(.blog-article__toc-list--mobile)');
  const tocMobile = document.querySelector('.blog-article__toc-list--mobile');
  if (!body || (!tocDesktop && !tocMobile)) return;

  const headings = body.querySelectorAll('h2, h3');
  if (!headings.length) return;

  const links = [];

  headings.forEach(function (heading, i) {
    const id = heading.id || heading.textContent.trim().toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '') + '-' + i;
    heading.id = id;

    const level = heading.tagName === 'H3' ? '3' : '2';
    const linkHTML = '<a href="#' + id + '" data-level="' + level + '">' +
      heading.textContent.trim() + '</a>';

    if (tocDesktop) tocDesktop.insertAdjacentHTML('beforeend', linkHTML);
    if (tocMobile) tocMobile.insertAdjacentHTML('beforeend', linkHTML);

    links.push({ id: id, el: heading });
  });

  // Smooth scroll
  document.querySelectorAll('.blog-article__toc-list a').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var target = document.getElementById(this.getAttribute('href').slice(1));
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', this.getAttribute('href'));
      }
      // Close mobile accordion
      var details = this.closest('details');
      if (details) details.removeAttribute('open');
    });
  });

  // Active heading tracking
  if (!('IntersectionObserver' in window)) return;

  var allLinks = document.querySelectorAll('.blog-article__toc-list a');

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        allLinks.forEach(function (l) { l.classList.remove('active'); });
        document.querySelectorAll('.blog-article__toc-list a[href="#' + entry.target.id + '"]')
          .forEach(function (l) { l.classList.add('active'); });
      }
    });
  }, {
    rootMargin: '-80px 0px -70% 0px',
    threshold: 0
  });

  links.forEach(function (link) { observer.observe(link.el); });
})();
